import React, { useState } from "react";
import { ICONS } from "../../../assets/icons";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Divider, Flex, Typography } from "antd";
const { Text } = Typography;

const GxToast = ({ toast, message, type, item, handleClick }) => {
  // const [imageBackgroundColor, setImageBackgroundColor] = useState("");
  const toastBeforeColors = {
    Success: "var(--primary)",
    Information: "var( --informationBlue )",
    Warning: "var( --secondary)",
    Error: "var(--backgroundRed)",
  };
  let imageBackgroundColor = "";
  const getIcon = (type) => {
    switch (type) {
      case "Success":
        imageBackgroundColor = "var(--primary)";
        return <img src={ICONS?.CircleCheck} alt="success" />;
      case "Information":
        imageBackgroundColor = "var( --informationBlue )";
        return <img src={ICONS?.infoIconViolet} alt="information" />;
      case "Warning":
        imageBackgroundColor = "var( --secondary)";
        return <img src={ICONS?.TrianglewarningIcon} alt="warning" />;
      case "Error":
        imageBackgroundColor = "var(--backgroundRed)";
        return <img src={ICONS?.WarningIcon} alt="error" />;
      default:
        return null;
    }
  };
  return (
    <Flex
      justify="space-between"
      align="center"
      className="rounded-xl shadow-md w-full max-w-md ps-2 pe-6 pb-[0.7rem] pt-[0.4rem]"
    >
      <Flex gap={22} align="center">
        <div
          className="w-[4px] h-[2.5rem] rounded-full"
          style={{ backgroundColor: toastBeforeColors[type] }}
        ></div>
        <Flex align="center" justify="space-between" gap={22}>
          {getIcon(type)}

          <Text className="text-gray-700 font-[500] text-[12px]">{message}</Text>
        </Flex>
      </Flex>
      <Button
        type="text"
        icon={<CloseOutlined />}
        onClick={() => toast.destroy()}
      />
    </Flex>
  );
};

export default GxToast;
